import { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';

import WorkList from 'components/WorkList';
import { WorkItemType } from 'components/WorkListItem';

import useCollabs from 'hooks/useCollabs';
import useFHRequest from 'hooks/useFHRequest';
// import useUserIdentity from 'hooks/useUserIdentity';
import useWorkKey from 'hooks/useWorkKey';
import RoleStack from './RoleStack';
import useClock from 'hooks/useClock';
import { pluralize } from 'utils/misc';
import { Success } from './FancyToast';

const IdentityCollabs = observer(() => {
    const { identityKey } = useParams();
    const workKey = useWorkKey();
    const {
        supportFetchCollabs,
        getCollabsCreatedBy
    } = useCollabs();
    const {
        supportFetchRequests,
        getListByIdentity
    } = useFHRequest();

    // const [requests, setRequests] = useState([] as WorkItemType[]);

    const { resetTotals } = useClock();
    const [loadingRequests, setLoadingRequests] = useState(false);
    const [loadingCollabs, setLoadingCollabs] = useState(false);
    const [requestCursor, setRequestCursor] = useState<string | null>(null);
    const [collabCursor, setCollabCursor] = useState<string | null>(null);
    const collabs = identityKey ? getCollabsCreatedBy(identityKey) : [] as WorkItemType[];
    const requests = identityKey ? getListByIdentity(identityKey) : [] as WorkItemType[];
    const status = 'active';

    function doFetchRequests() {
        if(!workKey) return;
        if(!identityKey) return;
        if(loadingRequests) return;
        if (status === 'active') {
            setLoadingRequests(true);
            supportFetchRequests(workKey, identityKey)
                .then((resp) => {
                    if(resp && resp.cursor)
                        setRequestCursor(resp.cursor);
                    else
                        setRequestCursor(null);
                })
                .finally(() => {
                    setLoadingRequests(false);
                });
        }
        else {
            setLoadingRequests(false);
        }
    }

    function doFetchCollabs() {
        if (!workKey) return;
        if (!identityKey) return;
        if (loadingCollabs) return;

        setLoadingCollabs(true);

        supportFetchCollabs(
            workKey,
            identityKey
        )
            .then((resp) => {
                if(resp && resp.cursor)
                    setCollabCursor(resp.cursor);
                else
                    setCollabCursor(null);
            })
            .finally(() => {
                setLoadingCollabs(false);
            });
    }

    /* load the requests */
    useEffect(() => {
        doFetchRequests();
    }, [workKey, supportFetchRequests]);

    /* Load the collabs */
    useEffect(() => {
        doFetchCollabs();
    }, [workKey, supportFetchCollabs]);

    const items = [...collabs, ...requests]
        .sort((a, b) => a.date_created > b.date_created ? 1 : -1);

    function doResetTotals() {
        if(!workKey) return;
        let i = 0;
        items.forEach((item) => {
            resetTotals(workKey, item.cls, item.uuid);
            console.log("rset", item.cls, item.uuid);
            i++;
        });
        Success(`Resetting ${i} Clock Totals`);
    }
    return (
        <Stack spacing={1} m={1}>
            <RoleStack role="manager">
                <Button size="sm" onClick={doResetTotals} variant="outlined">Reset Clock Totals for { pluralize(items.length, 'task') }</Button>
            </RoleStack>
            <WorkList
                loading={loadingRequests || loadingCollabs}
                title={<Typography>Created Collabs and Requests</Typography>}
                paged={false}
                items={items} />
            <Stack direction="row"
                justifyContent="flex-end"
                spacing={1}>
                { (requestCursor || collabCursor) &&
                    <Button
                        variant="plain"
                        loading={loadingRequests || loadingCollabs}
                        onClick={() => { doFetchRequests(); doFetchCollabs() }}
                    >Load More</Button>
                }
            </Stack>
        </Stack>
    );

});
export default IdentityCollabs;
